import { useRef, useState } from "react";
import StarIcon from "@mui/icons-material/Star";
import styled from "styled-components";

const PopularSliderMobile = ({ data, producturl, handleProductRoute }) => {
  const sliderRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const scrollToIndex = (index) => {
    if (!sliderRef.current) return;

    const cardWidth = sliderRef.current.children[0]?.offsetWidth || 0;
    const gap = 20; // Match your gap-6 class (1.5rem = 24px)
    const scrollPosition = index * (cardWidth + gap);

    sliderRef.current.scrollTo({
      left: scrollPosition,
      behavior: "smooth",
    });

    setCurrentIndex(index);
  };

  const handleNext = () => {
    const nextIndex = Math.min(
      currentIndex + 1,
      data.getPopularProduct?.length - getVisibleCardsCount()
    );
    scrollToIndex(nextIndex);
  };

  const handlePrev = () => {
    const prevIndex = Math.max(currentIndex - 1, 0);
    scrollToIndex(prevIndex);
  };

  const getVisibleCardsCount = () => {
    if (typeof window === "undefined") return 5;

    if (window.innerWidth >= 1280) return 5;
    if (window.innerWidth >= 1024) return 4;
    if (window.innerWidth >= 640) return 3;
    return 1;
  };

  return (
    // <div className="xl:max-w-[83rem] lg:max-w-[60rem] md:max-w-[50rem]  mx-auto">
    <ResponsiveContainer>
      {/* Products Slider Container */}
      <div className="relative">
        {/* Navigation Buttons */}
        <button
          onClick={handlePrev}
          disabled={currentIndex === 0}
          className="absolute left-[-18px] top-[32%] -translate-y-1/2 -translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg
            className="w-5 h-5 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={handleNext}
          disabled={
            currentIndex >=
            data?.getPopularProduct?.length - getVisibleCardsCount()
          }
          className="absolute right-[-18px] top-[32%] -translate-y-1/2 translate-x-4 z-10 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <svg
            className="w-5 h-5 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Products Slider */}
        <div
          ref={sliderRef}
          className="flex overflow-x-auto scrollbar-hidden snap-x snap-mandatory gap-6 pb-4 -mx-4 px-4"
          style={{ scrollBehavior: "smooth" }}
        >
          {data?.getPopularProduct?.map((item) => (
            <div
              key={item.product_id}
              className="flex-shrink-0 w-[calc(100%-2rem)] sm:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-1.5rem)] xl:w-[255px] snap-start cursor-pointer"
              onClick={() => handleProductRoute(item?.product_slug)}
            >
              <div className="bg-white rounded-xl overflow-hidden h-full">
                {/* <div className="relative aspect-square"> */}
                <div
                  className="w-[255px] h-[255px] overflow-hidden rounded-[23px] border"
                  style={{ borderColor: "rgba(237, 237, 237, 1)" }}
                >
                  <img
                    src={producturl + item.thumbnail}
                    alt={item.product_name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  {item.average_stars && (
                    <RatingBox>
                      <span style={{ fontSize: "14px", color: "#fff" }}>
                        {item?.average_stars}
                      </span>
                      <StarIcon style={{ fontSize: "14px", color: "#fff" }} />
                    </RatingBox>
                  )}
                </div>
                <div className="p-4">
                  <h3
                    className="text-[15px] font-medium text-gray-900 leading-[100%] font-[Poppins] max-w-[240px] truncate"
                    title={item.product_name}
                  >
                    {item.product_name}
                  </h3>
                  <div className="flex items-baseline py-3">
                    <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                      ₹{item.sale_price}/-
                    </span>
                    {item.mrp && (
                      <span className="font-poppins font-light italic text-sm leading-none line-through text-[#db0f0f] ps-4">
                        {item.mrp}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ResponsiveContainer>
  );
};

export default PopularSliderMobile;

const RatingBox = styled.div`
  position: absolute;
  top: 15px;
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  border-radius: 4px;
  gap: 2px;
  padding: 0 8px;
  background-color: rgba(24, 120, 55, 1); /* Or any background */
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;

const ResponsiveContainer = styled.div`
  margin: 0 auto;
  width: 100%;
//   max-width: 500px;
  @media (min-width: 1000px) {
    max-width: 600px;
  }
  @media (min-width: 1200px) {
    max-width: 700px;
  }
  @media (min-width: 1300px) {
    max-width: 800px;
  }
  @media (min-width: 1400px) {
    max-width: 900px;
  }
  @media (min-width: 1500px) {
    max-width: 980px;
  }
  @media (min-width: 1536px) {
    max-width: 1050px;
  }
  @media (min-width: 1600px) {
    max-width: 1130px;
  }
  @media (min-width: 1700px) {
    max-width: 1203px;
  }
  @media (min-width: 1800px) {
    max-width: 1303px;
  }
  @media (min-width: 1900px) {
    max-width: 1360px;
  }

  @media (min-width: 2000px) {
    max-width: 1499px;
  }
  @media (min-width: 2100px) {
    max-width: 1553px;
  }
  @media (min-width: 2200px) {
    max-width: 1653px;
  }
  @media (min-width: 2300px) {
    max-width: 1703px;
  }
  @media (min-width: 2400px) {
    max-width: 1803px;
  }
  @media (min-width: 2500px) {
    max-width: 1903px;
  }
  @media (min-width: 2600px) {
    max-width: 2003px;
  }
`;
